

<div class="ticket-box">
	<table class="ticket-box-table _sm">
		@if (appService.region !== 'US' && $storage.showPrices && $storage.order.printData.collections.ORDER_DISCOUNTS_LIST.length) {
			@for ( discount of $storage.order.printData.collections.ORDER_DISCOUNTS_LIST ; track discount) {
				<tr class="_base">
					<th colspan="2">{{ discount.DISCOUNT_NAME || 'PO.TICKET_DISCOUNT' | translate }}</th>
					<td>{{ (discount.DISCOUNT_AMOUNT * -1) | number:'1.2-2' }}</td>
				</tr>
			}
		}
		@for (offer of $storage.order.printData.collections.ORDERED_OFFERS_LIST; track offer; ) {
			@if (offer.OFFER_AMOUNT != 0 || offer.OFFER_PRICE != 0) {
				@if (!offer.OFFER_UNITS) {
					<tr class="_base">
							<th colspan="2">
								<span class="_counter">{{ offer.OFFER_QTY }}</span>
								<span>{{ offer.OFFER_NAME }}</span>
							</th>
						<td>
						@if (offer.ON_THE_HOUSE != '1' && $storage.showPrices) {
							<span>
								{{ (offer.OPEN_PRICE ? offer.OFFER_AMOUNT : offer.OFFER_AMOUNT) | number:'1.2-2' }}
							</span>
						}
						@if (offer.ON_THE_HOUSE == '1' && $storage.showPrices) {
							<span>{{ 'PO.OTH' | translate }}</span>
						}
						</td>
					</tr>
				}
				@if (offer.OFFER_UNITS) {
					<tr class="_base">
						<th>
							<span class="_counter">{{ offer.OFFER_QTY }}</span>
							<span>{{ offer.OFFER_NAME }}</span>
						</th>
						<td class="px-3">{{ offer.OFFER_UNITS | weight:$storage.order.printData.variables.BASIC_WEIGHT_UOM }}</td>
						<td>
							@if (offer.ON_THE_HOUSE != '1' && $storage.showPrices) {
								<span>{{ (offer.OFFER_QTY * offer.OFFER_PRICE * offer.OFFER_UNITS) | number:'1.2-2' }}</span>
							}
							@if (offer.ON_THE_HOUSE == '1' && $storage.showPrices) {
								<span>{{ 'PO.OTH' | translate }}</span>
							}
						</td>
					</tr>
				}
				@for (offerItem of offer.ALL_ORDERED_ITEMS; track offerItem) {
					@if (offerItem.IS_LEADING_ITEM != '1' && offerItem.ITEM_PRICE) {
					<tr>
						<th colspan="2">
							<span class="_counter"></span>
							{{ offerItem.ITEM_NAME }}
						</th>
						@if ($storage.showPrices && offerItem.ITEM_PRICE) {
							<td>{{ offerItem.ITEM_PRICE | number:'1.2-2' }}</td>
						}
					</tr>
					}

					@if (offerItem._hasMods) {
						@for ( pMod of offerItem.MODIFIERS_LIST | filterBy:{'_show':true} ; track pMod) {
							@if (!pMod.EXCLUDED && pMod.MODIFIER_PRICE > 0) {
  							<tr>
  								<th colspan="2"><span class="_counter-large"></span>{{pMod._name}}</th>
  								@if (pMod.MODIFIER_PRICE > 0 && $storage.showPrices) {
  									<td>{{pMod.MODIFIER_PRICE | number:'1.2-2'}}</td>
  								}
  							</tr>
  							}
						}
					}

					<!--
					@if (offerItem._hasModsExclude) {
					<tr>
						<th colspan="3" class="text-danger">
							<span class="_counter-large"></span>{{'PO.WITHOUT' | translate}}:
							@for ( pMod of offerItem.MODIFIERS_LIST | filterBy:{'_show':true, 'EXCLUDED':true}; track pMod; let last=$last) {
							<span>
								{{pMod.MODIFIER_NAME}}
								<span *ngIf="!last">, </span>
							</span>
							}
						</th>
					</tr>
					}
					-->
				}
			}
			@for ( discount of offer.ORDERED_OFFER_DISCOUNTS ; track discount) {
				@if ($storage.showPrices) {
					<tr>
						<th colspan="2"><span class="_counter-large"></span>{{ 'PO.ITEM_DISCOUNT' | translate }}
						</th>
						@if ($storage.showPrices) {
							<td>{{ discount.DISCOUNT_AMOUNT * -1 | number:'1.2-2' }}</td>
						}
					</tr>
				}
			}
		}
	</table>
</div>
